



















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { MomentMPListing } from '@/MomentMPListing'
import { TokenUser } from '@/TokenUser'
import * as utils from '@/utils';
import * as utils_time from '@/utils_time';
import * as utils_topshot from '@/utils_topshot';
import { Plotly } from '@rleys/vue-plotly-basic'
import ModalWrapperComponent from '@/components/ModalWrapperComponent.vue';           // @ is an alias to /src

@Component({
  name: 'MomentMPListingListComponent',
  components: { Plotly, ModalWrapperComponent }
})
export default class MomentMPListingListComponent extends Vue {
  // prop reactive member variables publically available to the html template
  @Prop({ default: null })
  public moment: MomentMPListing

  @Prop({ default: 0 })
  public index: number                 // in case it's ever useful for us to know where we are in the main list

  @Prop({ default: false })
  public showDiscount: boolean

  @Prop({ default: false })
  public showOwned: boolean

  @Prop({ default: false })
  public allowDrilling: boolean

  // public reactive member variables available to the html template
  public SHOW_IMAGE = true

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }
  public get user(): TokenUser { return this.$store.getters.userObject }
  public get userId(): string { return this.$store.getters.userId }

  public getNicePriceString(number): string { return utils_topshot.getNicePriceString(number)}
  public getNicePossibleDecimalPriceStringForFMV(number): string { return utils_topshot.getNicePossibleDecimalPriceStringForFMV(number)}  
  public getNicePossibleDecimalPriceString(number): string { return utils_topshot.getNicePossibleDecimalPriceString(number)}

  public showLedger(momentID: number, serial: number) {
    (this.$refs.MomentActivityFeedComponent as ModalWrapperComponent).show(`Timeline ⏳ for Serial #${serial}`, 'lg', { momentID: momentID })
  }

  public getOwnedToolTip(): string {
    if (this.user && this.user.topShotVerified) return 'How many of these moments you currently own.'
    return 'How many of these moments you currently own. You must be logged into your LiveToken account to see this.'
  }

  // May 23, 2024
  public getBuyText(moment: MomentMPListing) {
    if (moment.flowtyListingResourceID) return 'Flowty'
    return "Buy"
  }

  public onBuy() {
    // window.location.href = moment.getBuyURL()
    window.open(this.moment.getBuyURL(), "_blank"); 
  }

  public onDrill() {
    this.$emit('drill', this.moment)
  }

  // private, non-reactive member variables

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)
  }

  private async beforeDestroy() { if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`) }

}
